import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'strings'
})
export class StringsPipe implements PipeTransform {
  transform(value: string, index: number): string {
    if (!value) return '';
    return String.fromCharCode(value.charCodeAt(0) + index);
  }
}